import InvoiceService from './InvoiceService';

export default InvoiceService;
